export enum FitOption {
  SCROLL = "Scroll",
  ALL = "All",
  HEIGHT = "Height",
  WIDTH = "Width",
}
